import { DropdownMenu } from '../subscriptionComponents/DropdownMenu';

const ShareButton = ({
  loading = false,
  icon = null,
  onClick = null,
  style = {},
  menuClassName = 'ms-auto',
  className = '',
  itemClassName = '',
  menu = [],
}) => {
  return (
    <DropdownMenu
      buttonProps={{
        loading: loading,
        className: `lf-btn-1 btn-lg ${className}`,
        ...(onClick && { onClick: onClick }),
      }}
      style={style}
      className={menuClassName}
      itemClassName={itemClassName}
      button="Share"
      menu={menu}
      {...(icon && {
        button: icon,
      })}
    />
  );
};

export default ShareButton;
